//============================================================
// format
//============================================================
//Similar to the C# format function
// Use {#} where # = array index of replacement
// Use {| for no replacement (the pipe will be stripped)
// Arguments = the respective replacements
String.prototype.format = function(){
 var args = arguments;

 var str = this.replace(/{(\d+)}/g, function(match, num){
  //return typeof args[num] != "undefined" ? args[num] : match;
  return (args[num] != null && typeof args[num] != 'undefined') ? args[num] : "null/undefined";
 });

 //Clean any escaped brackets
 return str.replace("{|", "{");
};

//============================================================
// toBoolean
//============================================================
// Attempts to convert a string to its boolean equivalent.
// This approach works the opposite of the standard javascript approach.
// Instead of everything going to true except explict "false" values,
// everything here will go to false except explict "true" values.
String.prototype.toBoolean = function(){
    
    switch(this.toLowerCase()){
        case "1":
        case "true":
        case "y":           //Not sure if this one is a greta idea.  Leaving it for now.
            return true;
    }

    return false;
}